import React from 'react';
// @ts-ignore
import JmtMicroApp from '@jd/jmtd-micro-app';
import env from '@/env';

export default function DataPanel({ pageId }) {
  return <JmtMicroApp pageId={pageId} production={env.API_ENV === 'prod'} />;
}
